"use client";

/*eslint-disable */
import React from "react";

interface AccordionItemProps {
  showDescription: string;
  ariaExpanded: boolean;
  fontWeightBold: string;
  title: any;
  item: any;
  index: number;
  onClick: () => void;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  showDescription,
  ariaExpanded,
  fontWeightBold,
  title,
  item,
  index,
  onClick,
}) => (
  <div className="faq__question">
    <dt>
      <button
        aria-expanded={ariaExpanded}
        aria-controls={`faq${index + 1}_desc`}
        data-qa="faq__question-button"
        className={`faq__question-button ${fontWeightBold}`}
        onClick={onClick}
      >
        {title}
      </button>
    </dt>
    <dd>
      <p
        id={`faq${index + 1}_desc`}
        data-qa="faq__desc"
        className={`faq__desc ${showDescription}`}
      >
        {item}
      </p>
    </dd>
  </div>
);

export default AccordionItem;
